// extracted by mini-css-extract-plugin
module.exports = {"emaildiv":"StayUpdatedSection_emaildiv__qkCZt","inputDiv":"StayUpdatedSection_inputDiv__m3VCA","copyRights":"StayUpdatedSection_copyRights__bEDxY"};